<template>
  <b-modal
    :ref="popupRef"
    :title= "$t('dashboard.dashboardSharing.sharingModalHeader')"
    :modal-class="modalClass"
    hide-footer>
    <div
      v-show="isLoading"
      class="sharing-content font-family-notosanscjkkr-regular">
      <div class="loadingIndicator">
        <BaseLoadingIndicator/>
      </div>
    </div>
    <div
      v-show="!isLoading"
      class="sharing-content font-family-notosanscjkkr-medium">
      <div>
        <p>{{ $t('dashboard.dashboardSharing.sharingModalContent1') }}</p>
        <p>{{ $t('dashboard.dashboardSharing.sharingModalContent2') }}</p>
      </div>
      <div
        class="sharing-range">
        <b-row>
          <span
            class="font-14 mr-8 font-family-notosanscjkkr-medium">
            {{ $t('dashboard.dashboardSharing.shareRange') }}
          </span>
          <base-material
            v-b-tooltip.hover.html ="getTooltip()"
            id="share-option"
            :size="16"
            color="gray-1"
            name="info"
          />
        </b-row>
        <b-form-radio-group
          id="share-option"
          v-model="shareOption"
        >
          <b-row>
            <b-form-radio
              :value="withShareFilter"
              class="mb-2 remove-radio-padding"/>
            <p class="option-value-label" >{{ $t('dashboard.dashboardSharing.withShareFilter') }}</p>

            <b-form-radio
              :value="withoutShareFilter"
              class="mb-2 remove-radio-padding"/>
            <p class="option-value-label">{{ $t('dashboard.dashboardSharing.withoutShareFilter') }}</p>

          </b-row>
        </b-form-radio-group>
      </div>
      <div
        class="sharing-url-link-area"
        @click="selectUrl">
        <input
          id="sharing-url-text"
          :value="sharingUrl"
          type="text"
          class="sharing-url-link-box">
      </div>
    </div>
    <div class="confirm-popup-footer font-family-notosanscjkkr-medium">
      <b-button
        :style="{background: cancelButtonColor + '!important', color: cancelButtonTextColor + '!important'}"
        class="text-gray-1 button-cancel"
        @click = "hide">
        {{ cancelText }}
      </b-button>
      <b-button
        :style="{ background: confirmButtonColor + '!important',
                  color: confirmButtonTextColor + '!important',
                  border: confirmButtonBorder + '!important',
                  height: confirmButtonHeight + 'px!important' }"
        class="text-gray-1 button-confirm"
        @click = "onCopy">
        {{ confirmText }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  import { fetchDashboardUuid } from "../../../api/dashboard";
  import BaseLoadingIndicator from '@/components/common/BaseLoadingIndicator';
  import _get from "lodash/get";

  export default {
    name: "BaseConfirmPopup",
    components: {
      BaseLoadingIndicator
    },
    props: {
      popupRef: {
        type: String,
        required: true,
      },
      dashboardIndex: {
        type: Number,
        require: true,
        default: -1
      },
      cancelButtonColor: {
        type: String,
        default: "#fff",
      },
      cancelButtonText: {
        type: String,
        default: "",
      },
      cancelButtonTextColor: {
        type: String,
        default: "#0672FF",
      },
      confirmButtonColor: {
        type: String,
        default: "#dc3545",
      },
      confirmButtonText: {
        type: String,
        default: "",
      },
      confirmButtonTextColor: {
        type: String,
        default: "#fff",
      },
      confirmButtonBorder: {
        type: String,
        default: "none",
      },
      confirmButtonHeight: {
        type: String,
        default: "32",
      },
      modalClass: {
        type: String,
        default: 'dashboard-share-popup'
      }
    },
    data() {
      return {
        showModal: false,
        cancelText: this.$t("dashboard.dashboardSharing.cancel"),
        confirmText: this.$t("dashboard.dashboardSharing.copyUrl"),
        isLoading: false,
        sharingUrl: null,
        dashboardUuid: null,
        withShareFilter: "withShareFilter",
        shareOption: "withShareFilter",
        withoutShareFilter: "withoutShareFilter"
      }
    },
    watch: {
      dashboardIndex: {
        handler() {
          if(this.dashboardIndex > -1) {
            this.loadDashboardUuid(this.dashboardIndex)
          }
        },
        immediate: true
      },
      shareOption: {
        handler() {
          if(!_.isEmpty(this.dashboardUuid)) {
            if(_.isEqual(this.shareOption, this.withShareFilter)) {
              this.sharingUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}/${this.dashboardUuid}/${this.Base64.encode(this.$store.state.loginUser.curCmpnId)}/share`;
            }
            else {
              this.sharingUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}/${this.dashboardUuid}/share`;
            }
          }
        }
      },
      dashboardUuid: {
        handler() {
          if(_.isEqual(this.shareOption, this.withShareFilter)) {
            this.sharingUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}/${this.dashboardUuid}/${this.Base64.encode(this.$store.state.loginUser.curCmpnId)}/share`;
          } else {
            this.sharingUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}/${this.dashboardUuid}/share`;
          }
        }
      }
    },
    methods: {
      show() {
        this.$refs[this.popupRef].show();
      },
      hide() {
        this.$refs[this.popupRef].hide();
      },
      loadDashboardUuid(toShareDashboardIndex) {
        this.isLoading = true;
        fetchDashboardUuid(toShareDashboardIndex)
          .then(res => {
            this.isLoading = false;
            this.dashboardUuid = res;
          })
          .catch(err => {
            this.isLoading = false;
            console.error(err);
          })
      },
      selectUrl() {
        const input = document.getElementById("sharing-url-text");
        input.focus();
        input.select();
      },
      onCopy() {
        let sharingUrlToCopy = document.getElementById("sharing-url-text")
        sharingUrlToCopy.select();
        let msg = null;

        try {
          let successful = document.execCommand('copy');
          msg = successful ? this.$t('dashboard.dashboardSharing.copySuccessMsg') : this.$t('dashboard.dashboardSharing.copyFailMsg');
        } catch (err) {
          msg = this.$t('dashboard.dashboardSharing.copyErr')
        }

        window.getSelection().removeAllRanges()
        this.$emit('clickCopySharingUrl')
        this.hide();
        this.$toasted.global.showMessage({
          message: msg
        })
      },
      getTooltip() {
        return `
          <div class="txt-left">
            <div class="dashboard-share-tooltip">
              <p>${this.$t("dashboard.dashboardSharing.shareTooltip1")}</p>
              <br/>
              <p>${this.$t("dashboard.dashboardSharing.shareTooltip2")}</p>
              <p>${this.$t("dashboard.dashboardSharing.shareTooltip3")}</p>
              <br/>
              <p>${this.$t("dashboard.dashboardSharing.shareTooltip4")}</p>
            </div>
          </div>
        `;
      },
    },
  }
</script>

<style lang="scss">
  .dashboard-share-popup {
    .modal-header {
      width: 648px;
      text-align: center;
      .modal-title {
        width: 616px;
        position: absolute;
        font-size: 16px;
        font-family: NotoSansCJKkr-Medium;
      }
    }

    .modal-body {
      width: 648px;
      padding: 0 !important;
      .content-confirm-popup {
        padding: 30px;
        p {
          font-size: 16px;
        }
      }
    }

    .modal-content {
      width: 650px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) !important;
    }

    .sharing-content {
      height: 220px;
      color: #222222;
      width: 650px;
      border-bottom: 1px solid rgba(124, 129, 148, 0.25);
      font-size: 16px;
      padding: 25px 25px 25px 25px;
      position: relative;
      font-family: NotoSansCJKkr-Medium;
      .loadingIndicator {
        position: absolute;
        bottom: -30%;
        left: 55%;
      }
    }
    .sharing-range {
      color: #222222;
      font-size: 16px;
      padding-left: 15px;
      padding-top: 25px;
      position: relative;
      font-family: NotoSansCJKkr-Medium;
    }

    .sharing-url-link-area {
      background: #D3D8E0;
      border-radius: 4px;
      width: 600px;
      .sharing-url-link-box {
        padding-left: 2px;
        width: 600px;
        color: #0672ff;
        display: flex;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
  .remove-radio-padding {
    padding-right: 0 !important;
    padding-top: 4px;
    margin-right: 0 !important;
  }

  .option-value-label {
    padding-right: 16px;
    padding-bottom: 20px;
  }

  .button-cancel {
    outline: none;
    outline: 0;
    box-shadow: none !important;
    border-radius: 4px !important;
    margin-right: 25px !important;
    border: none;
  }

  .button-confirm {
    outline: none;
    outline: 0;
    background: #0672FF;
    box-shadow: none !important;
    border-radius: 4px !important;
  }

  .confirm-popup-footer {
    float: right;
    width: 650px;
    border-top: 1px solid rgb(230, 237, 249);
    text-align: right;
    height: 60px;
    padding-top: 12px;
    padding-right: 25px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/DashboardSharingModal.vue